<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap v-if="initStatus === 1">
      <v-flex lg8 xs12 order-lg1 order-xs2>
        <v-layout row wrap>
          <v-flex xs12>
            <general></general>
          </v-flex>
          <v-flex xs12>
            <premium></premium>
          </v-flex>
          <v-flex xs12>
            <shipment></shipment>
          </v-flex>
          <v-flex xs12>
            <clause></clause>
          </v-flex>
          <v-flex xs12>
            <insured></insured>
          </v-flex>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap class="pt-3">
              <v-btn color="secondary" :loading="quotation.saving" @click.prevent="doDecline">
                Decline Proposal
                <v-icon right dark>mdi-undo</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" :loading="quotation.saving" @click.prevent="doProceed">
                In-Force Proposal
                <v-icon right dark>mdi-arrow-right-bold-box</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex lg4 xs12 order-lg2 order-xs1>
        <quick-info query></quick-info>
      </v-flex>
    </v-layout>
    <loader v-else :card="false" :height="425" :init="doInit" loadText="Loading Cargo Quotation Details..." errorText="Failed to load Cargo Quotation Details" :loading="initStatus === 0"></loader>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_FAIL, AGENCY_QUOTATION_LEAVEQUOTE } from '@/store/types'
import QuickInfo from '../query/QuickInfo'
import General from '../query/General'
import Premium from '../query/Premium'
import Shipment from '../query/Shipment'
import Insured from '../query/Insured'
import Clause from '../query/Clause'
import { generalCargoForm } from '@/store/modules/agency/actions/quote'
import MessageMixin from '@/mixins/message'

export default {
  computed: {
    initStatus() {
      return this.$store.state.agency.quotation.init
    },
    quotation() {
      return this.$store.state.agency.quotation
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('cargoQuoteInit')
    },
    async doDecline() {
      const apiUrl = this.quotation.menu.declineApprovedQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalCargoForm(this.$store.state.agency))

          // After success push to query page
          const dispatchObj = {
            proposalNo: result.data.proposalNo,
            query: true
          }
          await this.$store.dispatch('loadQuote', dispatchObj)
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has been declined')
          this.$router.push({ name: 'cargoQuoteQuery', params: { id: result.data.proposalNo } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doProceed() {
      const apiUrl = this.quotation.menu.proceedApprovedQuote
      if (apiUrl) {
        try {
          this.$store.commit(AGENCY_QUOTATION_SAVE_LOADING)
          const result = await this.$http.post(apiUrl, generalCargoForm(this.$store.state.agency))

          // After success push to proposal page
          const dispatchObj = {
            proposalNo: result.data.proposalNo,
            query: true
          }
          await this.$store.dispatch('loadQuote', dispatchObj)
          this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
          this.$store.commit(AGENCY_QUOTATION_SAVE_SUCCESS)
          this.$snotify.success('Quotation has converted to In-Forced Proposal')
          this.$router.push({ name: 'cargoQuoteQuery', params: { id: result.data.proposalNo }, query: { if: true } })
        } catch (err) {
          if (err.response && err.response.data) {
            this.fullMessage(err.response.data)
          }
          // We need this to stop the loading (err msg will be displayed directly)
          this.$store.commit(AGENCY_QUOTATION_SAVE_FAIL, {})
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Set query mode on lifeCycle component (to disable editing of sales oppo)
    this.toggleQuery(true)

    if (this.initStatus !== 1) {
      this.doInit()
    }
  },
  components: {
    QuickInfo,
    General,
    Premium,
    Shipment,
    Insured,
    Clause
  },
  mixins: [
    MessageMixin
  ],
  props: {
    toggleQuery: {
      type: Function,
      default: function (queryMode) {
        return ''
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../../assets/scss/base.scss";
</style>
